<template>
  <div>
    <form
      novalidate
      class="md-layout"
      @submit.prevent="validateContent"
      enctype="multipart/form-data"
    >
      <md-card class="md-layout-item md-size-100 md-small-size-100">
        <md-card-header>
          <div class="md-title">Update Content</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('metaTitle')">
                <label for="metaTitle">Meta Title</label>
                <md-input
                  name="metaTitle"
                  id="metaTitle"
                  v-model="form.metaTitle"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.metaTitle.required">The meta title is required</span>
              </md-field>
            </div>
          </div>
          <md-field :class="getValidationClass('metaDescription')">
            <label for="metaDescription">Meta Description</label>
            <md-input
              name="metaDescription"
              id="metaDescription"
              autocomplete="metaDescription"
              v-model="form.metaDescription"
              :disabled="sending"
            />
            <span
              class="md-error"
              v-if="!$v.form.metaDescription.required"
            >The meta description is required</span>
          </md-field>
          <span style="color: red">{{serverErrors}}</span>
          <md-field :class="getValidationClass('title')">
            <label for="title">Title</label>
            <md-input
              type="title"
              name="title"
              id="title"
              autocomplete="title"
              v-model="form.title"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.title.required">The title is required</span>
          </md-field>
          <!-- <md-field>
            <img :src="form.logo" width="100" />
          </md-field>-->
          <md-field>
            <label>Logo</label>
            <md-file @md-change="handleLogoUpload($event)" accept="image/*" />
          </md-field>
          <md-field :class="getValidationClass('heading')">
            <label for="heading">Heading</label>
            <md-input
              name="heading"
              id="heading"
              autocomplete="heading"
              v-model="form.heading"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.heading.required">The heading is required</span>
          </md-field>
          <md-field :class="getValidationClass('subHeading')">
            <label for="subHeading">Sub Heading</label>
            <md-input
              type="subHeading"
              name="subHeading"
              id="subHeading"
              autocomplete="subHeading"
              v-model="form.subHeading"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.subHeading.required">The sub heading is required</span>
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending">Update Content</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "FormValidation",
  mixins: [validationMixin],
  data: () => ({
    form: {
      id: null,
      metaTitle: null,
      metaDescription: null,
      title: null,
      logo: null,
      heading: null,
      subHeading: null
    },
    sending: false,
    lastUser: null,
    serverErrors: ""
  }),
  validations: {
    form: {
      metaTitle: {
        required
      },
      metaDescription: {
        required
      },
      title: {
        required
      },
      heading: {
        required
      },
      subHeading: {
        required
      }
    }
  },

  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/api/content`)
      .then(res => {
        this.form.id = res.data._id;
        this.form.metaTitle = res.data.metaTitle;
        this.form.metaDescription = res.data.metaDescription;
        this.form.title = res.data.title;
        // this.form.logo = res.data.logo;
        this.form.heading = res.data.heading;
        this.form.subHeading = res.data.subHeading;
      })
      .catch(err => console.log(err));
  },

  methods: {
    handleLogoUpload(evt) {
      this.form.logo = evt[0];
      // console.log(evt[0]);
      // console.log(this.form.logo);
    },

    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    clearForm() {
      this.$v.$reset();
    },
    async saveContent() {
      this.sending = true;
      const content = {
        id: this.form.id,
        metaTitle: this.form.metaTitle,
        metaDescription: this.form.metaDescription,
        title: this.form.title,
        // file: this.form.logo,
        heading: this.form.heading,
        subHeading: this.form.subHeading
      };
      var formData = new FormData();
      if (this.form.logo != null) {
        await Object.keys(content).forEach(key => {
          formData.append(key, content[key]);
        });
        formData.append("file", this.form.logo);
        this.postContent(formData);
      } else {
        await Object.keys(content).forEach(key => {
          formData.append(key, content[key]);
        });
        this.postContent(formData);
      }
    },
    postContent(content) {
      axios
        .put(`${process.env.VUE_APP_API_URL}/api/content`, content)
        .then(() => {
          this.sending = false;
          this.clearForm();
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Content been updated.",
            showConfirmButton: false,
            timer: 1500
          });
          this.$router.push("/admin/content");
        })
        .catch(error => {
          this.sending = false;
          if (error.response.status === 422) {
            this.serverErrors = error.response.data.message;
          } else {
            alert(error);
          }
        });
    },

    validateContent() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveContent();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
</style>
